(function () {
  function normalizePhone(p) {
    return (p || '').toString().replace(/\s+/g, '').replace(/[^\d+]/g, '');
  }

  function getCenter(stores) {
    if (!stores.length) return { lat: 50.671345, lng: -4.19016 };

    var sumLat = 0;
    var sumLng = 0;
    var count = 0;

    stores.forEach(function (store) {
      var lat = parseFloat(store.lat);
      var lng = parseFloat(store.lng);
      if (!isNaN(lat) && !isNaN(lng)) {
        sumLat += lat;
        sumLng += lng;
        count += 1;
      }
    });

    return count ? { lat: sumLat / count, lng: sumLng / count } : { lat: 50.671345, lng: -4.19016 };
  }

  window.__rolexPreownedRealInitMap = function () {
    var sectionRoot = document.querySelector('.rolex-preowned-dynamic-map-component');
    if (!sectionRoot) return;

    var mapElement = sectionRoot.querySelector('.rolex-preowned-map-canvas');
    var drawerElement = sectionRoot.querySelector('.rolex-preowned-map-drawer');
    var storeCards = Array.prototype.slice.call(sectionRoot.querySelectorAll('.rolex-preowned-location-card[data-store-index]'));
    var dataEl = sectionRoot.querySelector('#rolex-preowned-stores-data') || document.querySelector('#rolex-preowned-stores-data');

    if (!mapElement || !drawerElement) return;

    var stores = [];
    if (dataEl && dataEl.textContent.trim()) {
      try {
        stores = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn('[Preowned Map] Bad JSON', e);
      }
    }

    if (!Array.isArray(stores)) {
      stores = [];
    }

    var normalizedStores = stores.map(function (store, index) {
      var card = storeCards[index];
      var normalizedStore = Object.assign({}, store);
      if (card) {
        if (!normalizedStore.lat && card.getAttribute('data-lat')) {
          normalizedStore.lat = card.getAttribute('data-lat');
        }
        if (!normalizedStore.lng && card.getAttribute('data-lng')) {
          normalizedStore.lng = card.getAttribute('data-lng');
        }
      }
      return normalizedStore;
    });

    if (normalizedStores.length < storeCards.length) {
      storeCards.forEach(function (card, index) {
        if (!normalizedStores[index]) {
          normalizedStores.push({
            lat: card.getAttribute('data-lat') || '',
            lng: card.getAttribute('data-lng') || ''
          });
        }
      });
    }

    stores = normalizedStores;

    var centerLocation = getCenter(stores);
    var map = new google.maps.Map(mapElement, {
      zoom: 10,
      center: centerLocation,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
      disableDefaultUI: true,
      styles: [
        { elementType: 'geometry', stylers: [{ color: '#f9f8f8' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#d3e0d4' }] },
        { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
        { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
        { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dddfe2' }] },
        { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
        { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
        { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c6d8e0' }] },
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }
      ]
    });

    var markerIcons = {
      default: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-black-button.svg?v=1778226756',
      selected: 'https://cdn.shopify.com/s/files/1/0063/4883/2856/files/map-location-pin-selected-black-button.svg?v=1778226756'
    };
    var markerSize = new google.maps.Size(40, 40);
    var markers = [];
    var markersByIndex = {};
    var activeMarker = null;

    function focusMarker(marker) {
      map.setOptions({ maxZoom: null });
      map.panTo(marker.getPosition());
      map.setZoom(18);
    }

    function clearActiveCards() {
      storeCards.forEach(function (card) {
        card.classList.remove('rolex-preowned-location-card-active');
      });
    }

    function setActiveCard(index) {
      clearActiveCards();
      var matchedCards = storeCards.filter(function (card) {
        return card.getAttribute('data-store-index') === String(index);
      });
      matchedCards.forEach(function (card) {
        card.classList.add('rolex-preowned-location-card-active');
      });
    }

    function resetMapToInitialView() {
      google.maps.event.trigger(map, 'resize');

      if (markers.length === 1) {
        map.setCenter(markers[0].getPosition());
        map.setZoom(14);
        return;
      }

      if (markers.length > 1) {
        var bounds = new google.maps.LatLngBounds();
        markers.forEach(function (marker) {
          bounds.extend(marker.getPosition());
        });
        // Padding keeps pins clear of the map edges instead of fitting them flush against it.
        map.setOptions({ maxZoom: null });
        map.fitBounds(bounds, 100);
        // Cap how far "+" can zoom the overview in, so a manual zoom-in click can't push a
        // pin back off the edge - the cap is lifted again in focusMarker() for a single store.
        google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
          map.setOptions({ maxZoom: map.getZoom() });
        });
        return;
      }

      map.setCenter(centerLocation);
      map.setZoom(10);
    }

    function closeDrawer() {
      drawerElement.classList.remove('rolex-preowned-map-drawer-active');
      drawerElement.innerHTML = '';
      markers.forEach(function (marker) {
        marker.setIcon({ url: markerIcons.default, scaledSize: markerSize });
        marker.setZIndex(1);
      });
      activeMarker = null;
      clearActiveCards();
      window.setTimeout(resetMapToInitialView, 120);
    }

    function getStoreValue(store, keys, fallback) {
      if (!store || typeof store !== 'object') {
        return fallback;
      }

      for (var i = 0; i < keys.length; i++) {
        var value = store[keys[i]];
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }

      return fallback;
    }

    function renderDrawer(store) {
      var storeData = store || {};
      var tel = normalizePhone(getStoreValue(storeData, ['phone', 'phoneNumber', 'phoneUrl'], ''));
      var tagsHtml = '';

      var tagOne = getStoreValue(storeData, ['tagOne', 'tag_1'], '');
      var tagTwo = getStoreValue(storeData, ['tagTwo', 'tag_2'], '');
      var tagThree = getStoreValue(storeData, ['tagThree', 'tag_3'], '');
      var showTagOne = storeData.showTagOne === true || storeData.showTagOne === 'true' || storeData.showTagOne === 1;
      var showTagTwo = storeData.showTagTwo === true || storeData.showTagTwo === 'true' || storeData.showTagTwo === 1;
      var showTagThree = storeData.showTagThree === true || storeData.showTagThree === 'true' || storeData.showTagThree === 1;

      var tagCount = 0;
      if (showTagOne && tagOne) tagCount++;
      if (showTagTwo && tagTwo) tagCount++;
      if (showTagThree && tagThree) tagCount++;

      if (tagCount > 0) {
        tagsHtml += '<div class="rolex-preowned-map-drawer-tags' + (tagCount > 1 ? ' is-flex' : '') + '">';
        if (showTagOne && tagOne) {
          tagsHtml += '<span class="active">' + tagOne + '</span>';
        }
        if (showTagTwo && tagTwo) {
          tagsHtml += '<span>' + tagTwo + '</span>';
        }
        if (showTagThree && tagThree) {
          tagsHtml += '<span class="service">' + tagThree + '</span>';
        }
        tagsHtml += '</div>';
      }

      var addressHtml = getStoreValue(storeData, ['addressHtml', 'address', 'addressLine'], '');
      var storeImage = getStoreValue(storeData, ['image', 'storeImage', 'imageUrl'], '');
      var storeTitle = getStoreValue(storeData, ['title', 'retailerTitle', 'name', 'storeName'], '');
      var rawPhone = getStoreValue(storeData, ['phone', 'phoneNumber', 'phoneUrl'], '');
      var storePhone = rawPhone.replace(/^tel:/i, '').trim(); 
      var tel = normalizePhone(rawPhone); 
      var storeMapLink = getStoreValue(storeData, ['mapLink', 'directionsUrl', 'directionsLink'], '#');
      var storeMessageLink = getStoreValue(storeData, ['messageLink', 'detailsLink', 'contactPage', 'moreDetailsLink'], '#');
      var storeMessageText = getStoreValue(storeData, ['messageText', 'detailsText', 'moreDetailsText'], 'More details');
      var storeImageHtml = storeImage ? '<img src="' + storeImage + '" alt="' + (storeTitle || 'Store') + '">' : '';

      drawerElement.innerHTML = [
        '<div class="rolex-preowned-map-drawer-inner">',
        '  <div class="rolex-preowned-map-drawer-image">' + storeImageHtml + '</div>',
        '  <div class="rolex-preowned-map-drawer-content">',
        '  <button class="rolex-preowned-map-drawer-close" type="button" aria-label="Close drawer"></button>',
        '    <h3>' + storeTitle + '</h3>',
        '    <div class="rolex-preowned-map-drawer-address">' + addressHtml + '</div>',
        '    <ul class="rolex-preowned-map-drawer-links">',
        '      <li><a href="' + (tel ? ('tel:' + tel) : '#') + '"><span class="svg"><svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="m4.84 4.97-.08.03c.54 1.9 1.63 4.09 3.76 6.08l.16-.14c.83-.73 2.06-.88 2.75-.33l1.21 1.07c.67.54.65 1.5-.13 2.24-.42.49-3.43 3.57-7.98-3.6-4.77-7.56-1.9-9.63-.66-10.15.02-.01.04-.01.06-.02.03-.01.07-.02.1-.04.01 0 .03-.01.04-.01.18-.06.29-.08.29-.08s0 0 0 .01c.82-.15 1.49.25 1.74.92 0 0 1.13 3.4-1.26 4.02z"></path></svg></span><span>' + storePhone + '</span></a></li>',
        '      <li><a href="' + storeMapLink + '" ><span class="svg"><svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="m0 8.77 15-8.77-7.64 15-1.98-5.09z"></path></svg></span><span>Get directions</span></a></li>',
        '      <li><a href="' + storeMessageLink + '"><span class="svg"><svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve"> <path d="M15,8.8H8.8V15H6.2V8.8H0V6.2h6.2V0h2.5v6.2H15V8.8z"/> </svg></span><span>' + storeMessageText + '</span></a></li>',
        '    </ul>',
        '  </div>',
        '</div>'
      ].join('');

      var closeBtn = drawerElement.querySelector('.rolex-preowned-map-drawer-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
      }

      drawerElement.classList.add('rolex-preowned-map-drawer-active');
    }

    stores.forEach(function (store, index) {
      var lat = parseFloat(store.lat);
      var lng = parseFloat(store.lng);
      if (isNaN(lat) || isNaN(lng)) {
        console.warn('[Preowned Map] Skipping invalid coordinates', store);
        return;
      }

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        title: store.title || '',
        icon: { url: markerIcons.default, scaledSize: markerSize },
        zIndex: 1
      });

      marker.rolexPreownedStore = store;
      marker.rolexPreownedStoreIndex = index;
      markersByIndex[index] = marker;

      marker.addListener('click', function () {
        markers.forEach(function (item) {
          item.setIcon({ url: markerIcons.default, scaledSize: markerSize });
          item.setZIndex(1);
        });
        marker.setIcon({ url: markerIcons.selected, scaledSize: markerSize });
        marker.setZIndex(999);
        activeMarker = marker;
        setActiveCard(index);
        focusMarker(marker);
        renderDrawer(marker.rolexPreownedStore || store);
      });

      markers.push(marker);
    });

    storeCards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        var index = parseInt(card.getAttribute('data-store-index'), 10);
        if (isNaN(index)) return;
        var marker = markersByIndex[index];
        if (marker) {
          google.maps.event.trigger(marker, 'click');
        }
      });
    });

    map.addListener('click', function () {
      closeDrawer();
    });

    var closeButton = drawerElement.querySelector('.rolex-preowned-map-drawer-close');
    if (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    }

    window.setTimeout(function () {
      resetMapToInitialView();
    }, 120);

    window.addEventListener('resize', function () {
      google.maps.event.trigger(map, 'resize');
    });
  };

  if (window.__rolexPreownedInitQueue && window.__rolexPreownedInitQueue.length) {
    window.__rolexPreownedInitQueue = [];
    if (typeof window.__rolexPreownedRealInitMap === 'function') {
      window.__rolexPreownedRealInitMap();
    }
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  if (window.__rolexPreownedInitQueue) {
    window.__rolexPreownedInitQueue = [];
  }
});
